import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricAvgHotelRank extends MetricBase {
    constructor() {
        super({
            field: "metric_avg_hotel_rank",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.kayak.avgHotelRank.chartName"),
            serieLabel: i18n.t("metrics.kayak.avgHotelRank.serieLabel"),
            tooltip: i18n.t("metrics.kayak.avgHotelRank.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricAvgHotelRank;
